import { render, staticRenderFns } from "./HelpImageSize.vue?vue&type=template&id=120cf6d6&scoped=true"
import script from "./HelpImageSize.vue?vue&type=script&lang=js"
export * from "./HelpImageSize.vue?vue&type=script&lang=js"
import style0 from "./HelpImageSize.vue?vue&type=style&index=0&id=120cf6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120cf6d6",
  null
  
)

export default component.exports